import { Login } from '@myosh/myosh-login';

const LoginPage = () => {
  return <Login redirectPath="/" />;
};

export default LoginPage;
